import React from "react";
import styled from "styled-components";

const InfoFooterItem = ({ children }) => <Wrapper>{children}</Wrapper>;

export default InfoFooterItem;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 20px 20px;
  @media (min-width: 768px) {
    flex-direction: row;
    margin: 0 0 30px 0;
    min-width: 33%;
  }
  @media (min-width: 1100px) {
    flex-direction: row;
    margin: 0 0 30px 0;
    min-width: 45%;
  }
`;
